import React from "react";
import "./index.scss";
import i18n from "../../locales/i18n";
import { Box } from "fds";

const PrivacyPage = ({ height = "100%" }: { height?: string | number }) => {
  return (
    <Box classes="wsTermsPage" height={height}>
      {i18n.language.includes("ko") ? (
        <ul>
          <li>
            <h3 className="title">1. 총칙</h3>
            <p className="contents">
              개인정보란 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는
              성명, 주민등록번호 등의 사항에 의하여 해당 개인을 식별할 수 있는
              정보(해당 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와
              용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.
            </p>
            <p className="contents">
              주식회사 파수(이하 “당사”)는 고객정보보호를 가장 소중하게
              생각하며, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
              “정보통신망법”) 및 개인정보보호 법을 비롯한 모든 개인정보보호 관련
              법률규정을 지키고 있습니다.
            </p>
            <p className="contents">
              당사는 개인정보취급(처리)방침을 통하여 회원께서 제공하시는
              개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를
              위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </p>
            <p className="contents">
              당사는 개인정보처리방침을 홈페이지 첫 화면 또는 서비스 가입 화면에
              공개함으로써 회원께서 언제나 쉽게 보실 수 있도록 조치하고
              있습니다.
            </p>
            <p className="contents">
              본 Wrapsody eCo 서비스(이하 “서비스”)의 개인정보처리방침은 관련
              법률 및 관련 규정의 변경 또는 운영 방침의 변경에 따라 바뀔 수
              있습니다. 개인정보처리방침이 변경되면 바뀐 사항을 홈페이지에
              공지함으로써 개정된 내용을 회원께서 쉽게 알아보실 수 있도록 하고
              있습니다.
            </p>
          </li>
          <li>
            <h3 className="title">2. 수집하는 개인정보 항목 및 방법</h3>
            <p className="contents">
              당사는 회원의 개인정보를 기본적인 서비스 제공을 위해 다음의 정보를
              수집하고 있습니다.
            </p>
            <ul>
              <li>
                <h4 className="subTitle">① 수집항목</h4>
                <table className="wsTable">
                  <thead>
                    <tr>
                      <th className="th">수집정보</th>
                      <th className="th">이용목적</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="td">
                        E-mail, 이름, 서비스 이용기록, 이용정지 기록, 이용해지
                        기록, IP정보, 접속로그, 유료상품 가입/해지 이력 및
                        청구/수납 정보 및 기록
                      </td>
                      <td className="td">
                        서비스 관련 고지사항 전달, 본인 의사 확인, 불만 처리 등
                        원활한 의사소통 경로의 확보
                        <br />
                        Wrapsody eCo 서비스 관련 새로운 서비스/ 신상품 안내에
                        이용
                        <br />
                        서비스 관련 오류내용 확인을 위한 기초 데이터 및 불만
                        처리 용도로 활용
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <h4 className="subTitle">② 수집방법</h4>
                <p className="contents">
                  당사의 홈페이지 및 로그 분석 프로그램을 통한 정보 수집 등.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">3. 개인정보 수집에 대한 동의</h3>
            <p className="contents">
              회원 가입 및 서비스 이용과정에서 필요 최소한의 범위로 개인정보를
              수집하며, 그 수집 항목 및 목적을 사전에 고지합니다. 서비스를
              이용하고자 하는 고객이 서비스이용약관 및 본 개인정보처리방침을
              읽고 필수항목을 입력한 후 “가입완료” 버튼을 누르거나, “확인” 내지
              “동의합니다”에 체크하는 경우 개인정보의 처리에 동의한 것으로
              봅니다.
            </p>
          </li>
          <li>
            <h3 className="title">4. 수집하는 개인정보의 보유 및 이용기간</h3>
            <p className="contents">
              회원 탈퇴, 개인정보의 수집 및 이용목적이 달성된 경우 회원의
              개인정보를 지체 없이 파기합니다. 단, 상법 등 관련법령의 규정에
              의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로
              일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th">근거법령</th>
                  <th className="th">보존정보</th>
                  <th className="th">보존기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td">
                    전자상거래 등에서의 소비자보호에 관한 법률
                  </td>
                  <td className="td">계약 또는 청약철회에 관한 기록</td>
                  <td className="td">5년</td>
                </tr>
                <tr>
                  <td className="td">
                    전자상거래 등에서의 소비자보호에 관한 법률, 상법,
                    국세기본법, 소득세법, 법인세법, 부가가치세법
                  </td>
                  <td className="td">
                    대금 결제 및 재화 등의 공급에 관한 기록, 상업장부와 영업에
                    관한 전표, 증빙서류
                  </td>
                  <td className="td">5년</td>
                </tr>
                <tr>
                  <td className="td">
                    전자상거래 등에서의 소비자보호에 관한 법률
                  </td>
                  <td className="td">
                    소비자의 불만 또는 분쟁처리에 관한 기록
                  </td>
                  <td className="td">3년</td>
                </tr>
                <tr>
                  <td className="td">통신비밀보호법</td>
                  <td className="td">사이트 방문에 관한 기록</td>
                  <td className="td">3개월</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">5. 개인정보 파기절차 및 방법</h3>
            <ul>
              <li>
                <h4 className="subTitle">개인정보 파기절차</h4>
                <p className="contents">
                  고객이 서비스 가입 등을 위해 기재한 개인정보는 서비스 해지 등
                  이용목적이 달성된 후 내부 방침과 기타 관련 법령에 따른
                  정보보호 방침에 따라 삭제되거나 파기됩니다. 일반적으로
                  채권-채무 관계가 없다면, 회원으로 가입할 때 수집하여 전자적
                  파일 형태로 관리하는 개인정보는 회원 탈퇴 시점에 바로
                  삭제됩니다.
                </p>
              </li>
              <li>
                <h4 className="subTitle">개인정보 파기방법</h4>
                <p className="contents">
                  서면양식에 기재하거나, 종이에 출력된 개인정보는 분쇄기로 분쇄
                  또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고, 전자적
                  파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
                  방법을 사용하여 삭제합니다.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              6. 회원 및 법정대리인의 권리와 그 행사 방법
            </h3>
            <p className="contents">
              회원 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만
              14세 미만 아동의 개인정보를 조회 하거나 수정할 수 있으며,
              가입해지를 요청할 수도 있습니다.
            </p>
            <p className="contents">
              회원 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
              계정정보를, 가입해지(동의철회)를 위해서는 계정정보의 “회원탈퇴”를
              클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가
              가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로
              연락하시면 지체 없이 조치하겠습니다.
            </p>
            <p className="contents">
              귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을
              완료하기 전까지 당해 개인정보를 이용 또는 제3자에게 제공하지
              않습니다. 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
              처리결과를 제3자에게 지체 없이 통지하겠습니다.
            </p>
            <p className="contents">
              회사는 회원 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된
              개인정보는 “4. 회사가 수집하는 개인정보의 보유 및 이용기간”에
              명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
              없도록 처리하고 있습니다.
            </p>
            <p className="contents">
              회원의 개인정보를 최신의 상태로 정확하게 입력하여 주시기 바랍니다.
              회원이 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 회원
              자신에게 있으며 타인 정보의 도용 등 허위정보를 입력할 경우
              회원자격이 상실될 수 있습니다.
            </p>
            <p className="contents">
              회원은 개인정보를 보호받을 권리와 함께 타인의 정보를 침해하지 않을
              의무도 가지고 있습니다. 비밀번호를 포함한 회원의 개인정보가
              유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를
              훼손하지 않도록 유의해 주십시오. 만약 타인의 정보를 훼손할 시에는
              「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등에 의해
              처벌받을 수 있습니다.
            </p>
          </li>
          <li>
            <h3 className="title">
              7. 개인정보보호를 위한 기술 및 관리적 대책
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">기술적 대책</h4>
                <p className="contents">
                  회사는 고객님의 개인정보가 분실, 도난, 누출, 변조 또는
                  훼손되지 않도록 다음과 같은 기술적 대책을 마련하고 있습니다.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      ① 개인정보는 비밀번호(PASSWORD)에 의해 보호되며 파일 및
                      전송데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여
                      중요한 데이터는 별도의 보안기능으로 보호하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게
                      전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ 해킹 등 외부침입에 대비하여 서버마다 침입 차단 시스템과
                      취약점 분석 시스템 등을 이용하는 등 보안에 최선을 다하고
                      있습니다.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">관리적 대책</h4>
                <ul>
                  <li>
                    <p className="contents">
                      ① 개인정보의 안전한 보호를 위하여 정보보호관리체계 등에
                      대한 객관적인 인증을 받아 주요 시스템과 설비를 운영하고
                      있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② 개인정보에 대한 접근 및 관리에 필요한 절차 등을 마련하여
                      소속 직원으로 하여금 이를 숙지하여 지키도록 하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고
                      있습니다. 최소한의 인원에 해당하는 자는 다음과 같습니다
                    </p>
                    <ul>
                      <li>
                        <p className="contents">
                          a. 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          b. 개인정보 관리책임자, 담당자 등 개인정보 관리업무를
                          수행하는 자
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          c. 기타 업무상 개인정보의 취급이 불가피한 자
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="contents">
                      ④ 개인정보에 대한 접근과 관리에 필요한 절차 등을 마련하여
                      소속 직원으로 하여금 이를 숙지하여 지키도록 하고 있으며,
                      개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득
                      및 개인정보보호 의무 등에 관한 정기적인 사내 교육과 외부
                      위탁교육을 시행하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑤ 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된
                      상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보
                      사고에 대한 책임을 명확히 하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑥ 전산실과 자료 보관실 등을 특별보호구역으로 설정하여
                      출입을 통제하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑦ 컴퓨터를 이용하여 고객의 개인정보를 처리할 때에는
                      개인정보에 대한 접근권한이 있는 담당자를 지정하여
                      식별부호(ID)와 비밀번호(PASSWORD)를 부여하고, 해당
                      비밀번호(PASSWORD)를 정기적으로 갱신하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑧ 신규직원을 채용할 때 정보보호서약서 또는
                      개인정보보호서약서에 서명하게 하여 직원에 의한 정보유출을
                      사전에 방지하고 있으며 개인정보처리방침에 대한 이행사항과
                      직원의 준수 여부를 감사하기 위한 내부 절차를 마련해
                      지속적으로 시행하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑨ 직원이 퇴직할 때 비밀유지서약서에 서명하게 함으로써
                      고객의 개인정보를 취급하였던 자가 직무상 알게 된
                      개인정보를 훼손, 침해 또는 누설하지 않도록 하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑩ 서비스 이용계약 체결, 서비스 제공 등을 위하여 고객의
                      신용카드번호, 은행결제계좌 등 대금결제에 관한 정보를
                      수집하거나 고객에게 제공할 때 회사는 해당 고객이 본인임을
                      확인하도록 조치하고 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑪ 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에
                      일어나는 일에 대해 책임을 지지 않습니다. 회원 개개인은
                      본인의 개인정보를 보호하기 위하여 자신의 이메일(e-mail) 과
                      비밀번호(PASSWORD)를 적절하게 관리하고 이에 대해 책임을
                      져야 합니다. 또한, 다른 사람이 추측할 수 있는 쉬운
                      비밀번호(PASSWORD)는 사용을 피하기를 권장하며, 정기적으로
                      비밀번호(PASSWORD)를 변경하는 것이 바람직합니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑫ 공동으로 사용하는 PC에서 저희 홈페이지에 접속하여
                      로그인한 상태에서 다른 사이트로 이동할 경우에 서비스
                      이용을 종료하고자 한다면 반드시 로그아웃 한 후 해당
                      홈페이지를 종료하시기 바랍니다. 그렇지 않으면, 해당
                      브라우저를 통해 이메일(e-mail), 비밀번호(PASSWORD) 등
                      고객님의 정보가 타인에게 쉽게 유출될 수 있습니다.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑬ 그 밖에 내부 관리자의 실수나 기술 관리상의 사고로
                      개인정보의 상실, 유출, 변조, 훼손이 유발되면 당사는 즉각
                      그 사실을 알리고 적절한 대책과 보상을 마련할 것입니다.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">외부 API를 통한 개인정보 활용 제한</h4>
                <ul>
                  <li>
                    <p className="contents">
                      당사는 Google Workspace API를 포함한 외부 API를 통해
                      수집한 사용자 데이터를 일반화된 인공지능(AI) 및
                      머신러닝(ML) 모델의 개발, 개선 또는 훈련 목적으로 사용하지
                      않습니다.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">8. 개인정보관리 책임자</h3>
            <p className="contents">
              회원의 개인정보보호를 가장 중요시하며, 회원의 개인정보가
              훼손ㆍ침해 또는 누설되지 않도록 최선을 다하고 있습니다. 회사의
              귀책사유에 의하여 회원의 개인정보에 대한 침해사고가 발생하는
              경우에는 개인정보보호법 및 “정보통신망법” 등 관련 법령에서 정하는
              절차와 방법에 따라 회원에게 고지하고, 관련 기관에 신고합니다.
              다만, 관련 법령에 따라 기술적인 보안조치를 했음에도 불구하고, 해킹
              등 기본적인 네트워크상의 위험성에 의해 발생하는 예기치 못한 사고로
              인한 정보의 훼손 및 방문자가 작성한 게시물에 의한 각종 분쟁에
              관해서는 책임이 없습니다.
            </p>
            <p className="contents">
              회원의 개인정보를 보호하고 개인정보와 관련한 불만사항 및 문의를
              처리하기 위하여 아래와 같이 관련 부서 및 개인정보 관리 책임자를
              지정하고 있습니다.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th" scope="col"></th>
                  <th className="th" scope="col">
                    개인정보관리책임자
                  </th>
                  <th className="th" scope="col">
                    개인정보보호관리담당자
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="th" scope="row">
                    성명
                  </th>
                  <td className="td">김용길</td>
                  <td className="td">박현수</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    직위
                  </th>
                  <td className="td">상무</td>
                  <td className="td">수석</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    이메일
                  </th>
                  <td className="td">kimyg@fasoo.com</td>
                  <td className="td">hspark@fasoo.com</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    전화번호
                  </th>
                  <td className="td" colSpan={2}>
                    02-300-9120
                  </td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">9. 고지의 의무</h3>
            <p className="contents">
              현 개인정보취급(처리)방침은 2025년 3월 14일에 개정되었으며 정부의
              정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을
              시에는 개정 최소 7일 전부터 홈페이지를 통해 고지할 것입니다.
            </p>
            <p className="contents">
              개인정보취급(처리)방침 시행일자 : 2025년 3월 14일
            </p>
          </li>
        </ul>
      ) : (
        <ul>
          <li>
            <h3 className="title">1. General Provisions</h3>
            <p className="contents">
              Personal information is defined as information that identifies an
              individual (including that which can be identified by combining it
              with other information, when it cannot identify an individual with
              the relevant information alone) with items that are included in
              the relevant information about an individual, such as their name
              and resident registration number.
            </p>
            <p className="contents">
              Fasoo Co., Ltd ("the Company") takes customer information
              protection first and closely observes all domestic legislation,
              including the Act on Promotion of Information and Communications
              Network Utilization and Information Protection, etc. ("Information
              and Communications Network Act") and Personal Information
              Protection Act.
            </p>
            <p className="contents">
              The Company's privacy policy provides information regarding the
              purposes and uses of the personal information provided by the
              customer and indicates the kinds of measures that are taken to
              protect the personal information through our privacy policy.
            </p>
            <p className="contents">
              The Company reserves the right to change, amend or modify this
              Privacy Policy of Wrapsody eCo Service ("the Services") in
              accordance with applicable law, regulations, and policies, and, in
              such case, the Company discloses the privacy policy on the Company
              where the customer can find it with ease.
            </p>
          </li>
          <li>
            <h3 className="title">
              2. Items of Collected Personal Information and Methods of
              Collection
            </h3>
            <p className="contents">
              The company collects and processes the following personal
              information to provide basic services.
            </p>
            <ul>
              <li>
                <h4 className="subTitle">
                  ① Personal information to be collected
                </h4>
                <table className="wsTable">
                  <thead>
                    <tr>
                      <th className="th">Information to be collected</th>
                      <th className="th">Purpose of use</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="td">
                        E-mail, name, service usage records, Service suspension
                        records, Service termination records, IP information,
                        access log, Paid plan subscription/ subscription
                        history, billing/payment information and history
                      </td>
                      <td className="td">
                        To secure communication channels to deliver
                        service-related notifications, to confirm the customer's
                        intention, and to handle complaints.
                        <br />
                        To guide new services/products regarding Wrapsody eCo
                        service.
                        <br />
                        To use as basic data for checking service-related errors
                        and handling complaints.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <h4 className="subTitle">
                  ② Methods of collecting personal information
                </h4>
                <p className="contents">
                  Information is collected through the Company's website and log
                  analysis program.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              3. Consent to Collection of Personal Information
            </h3>
            <p className="contents">
              The minimum personal information is collected when a user signs up
              for the Service or while the user uses the Services. In case of
              collecting personal information, the company informs the items to
              collect and purposes to a user in advance. If a customer who wants
              to use the service reads the Terms of Service and this Privacy
              Policy, enters the required items, and clicks the "Complete"
              button for sign-up or checks the "OK" or "I Agree" checkbox, it is
              assumed that the user consents to the processing of personal
              information.
            </p>
          </li>
          <li>
            <h3 className="title">
              4. Retention and Use Period of Personal Information
            </h3>
            <p className="contents">
              When a member withdraws or the purpose of collecting and using
              personal information is achieved, the personal information of the
              member is destroyed without delay. However, it is retained for a
              certain period of time if it is necessary for reasons such as the
              confirmation of the management obligations regarding transaction
              in accordance with the provisions of related laws and regulations
              such as the Commercial Act.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th">Grounds Act</th>
                  <th className="th">Information to be retained.</th>
                  <th className="th">Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce
                  </td>
                  <td className="td">
                    Records on contract or withdrawal of subscription
                  </td>
                  <td className="td">5 year</td>
                </tr>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce, Commercial
                    Law, Basic National Tax Law, Income Tax Law, Corporate Tax
                    Law, VAT Law
                  </td>
                  <td className="td">
                    Records on payment and supply of goods, etc, commercial
                    accounting books and statements of business, and documentary
                    evidences
                  </td>
                  <td className="td">5 year</td>
                </tr>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce
                  </td>
                  <td className="td">
                    Records of consumer complaints or disputes
                  </td>
                  <td className="td">3 year</td>
                </tr>
                <tr>
                  <td className="td">Communication Secret Protection Act</td>
                  <td className="td">Records of site visits</td>
                  <td className="td">3 month</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">
              5. The Procedure and Methods to Dispose of Personal Information
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">Processes of disposal</h4>
                <p className="contents">
                  Personal information entered by customers for service
                  subscription is deleted or destroyed in accordance with the
                  internal policy and information protection policy according to
                  other related laws after the purpose of use is achieved for
                  reasons such as termination of service. Generally, if there is
                  no debt relationship, personal information collected when
                  registering as a member and managed in the form of an
                  electronic file is immediately deleted upon membership
                  withdrawal.
                </p>
              </li>
              <li>
                <h4 className="subTitle">Methods of disposal</h4>
                <p className="contents">
                  A. Personal information in written documents: shredding,
                  incineration, or chemical decomposition
                </p>
                <p className="contents">
                  B. Personal information in digital file forms: deleted by
                  using technology that prevents the recovery of such records
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              6. The Rights of Members and Legal Representatives and How to
              Exercise the rights
            </h3>
            <p className="contents">
              Registered members and legal representatives can view or modify
              personal information of their own or children under the age of 14
              at any time and may request termination of membership.
            </p>
            <p className="contents">
              The personal information of a member of a child under the age of
              14 can be viewed or modified by clicking Account Information. The
              subscription can be canceled (consent withdrawal) by clicking the
              "Withdrawal of Membership" and going through the identity
              verification process. Or the member can contact the person in
              charge of personal information management by writing, telephone,
              or email, the company will take action without delay.
            </p>
            <p className="contents">
              If you request to correct an error in personal information, the
              personal information will not be used or provided to a third party
              until the correction is completed. If incorrect personal
              information has already been provided to a third party, we will
              notify the third party without delay.
            </p>
            <p className="contents">
              The company handles the personal information that is withdrawn or
              deleted at the request of a member or legal representative as
              described in "4. Retention and Use Period of Personal Information"
              and processes it so that it cannot be viewed or used for other
              purposes.
            </p>
            <p className="contents">
              Please enter your personal information accurately and up to date.
              Members are responsible for accidents caused by incorrect
              information entered by members, and you will lose your
              qualifications for membership if false information such as theft
              of other information is entered.
            </p>
            <p className="contents">
              Members have an obligation not to infringe on other's information
              along with the right to privacy. Be careful not to leak personal
              information of members, including passwords, and be careful not to
              damage other people's personal information, including posts. If
              you damage other people's information, you may be punished by the
              Act on Promotion of Information and Communication Network
              Utilization and Information Protection, etc.
            </p>
          </li>
          <li>
            <h3 className="title">
              7. Technical/organizational Management for the Protection of
              Personal Information
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">Technical measures</h4>
                <p className="contents">
                  FASOO takes the following technical measures to secure the
                  stability of the personal information of our customers, so
                  that there is no loss, theft, leakage, external attack or
                  damage to the information.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      ① The personal information of the customer is secured
                      using passwords, and important data is protected with a
                      special security function by encrypting or locking the
                      file and the transmission data.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② The Company selects the security solution (SSL or SET)
                      for the safe transmission of personal information, using
                      an encrypted algorithm.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ The Company is fully engaged in security matters by
                      using a firewall system and a vulnerability analysis
                      system on each server, to prevent external attacks such as
                      hacking.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">Organizational measures</h4>
                <ul>
                  <li>
                    <p className="contents">
                      ① For the safe protection of personal information, we are
                      operating major systems and facilities with certified
                      information protection management systems by an objective
                      certification body.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② The Company implemented required processes to access
                      personal information and to manage and ensure the
                      employees are aware of and follow the processes.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ The Company shall minimize the number of persons
                      authorized to access personal information on customers as
                      follows.
                    </p>
                    <ul>
                      <li>
                        <p className="contents">
                          a. Those who conduct direct marketing activities
                          toward users
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          b. Those who manage personal information including
                          Privacy Supervisor and Privacy Personnel
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          c. Those who are obligated to handle personal
                          information due to business
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="contents">
                      ④ The Company implemented required processes to access
                      personal information and to manage and ensure the
                      employees are aware of and follow the processes, and holds
                      regular company training and outsourced training for
                      employees who deal with personal information to acquire
                      new security technology and methods of protecting personal
                      information.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑤ Transferring duties and responsibilities between people
                      who handles personal information is performed thoroughly
                      while security is maintained. We clarify where the
                      responsibility lies for personal information accidents
                      after employees leave the company or join the Company.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑥ The computer room and data storage room are set as
                      special protected areas to control access.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑦ When processing a customer's personal information using
                      a computer, a person with access to the personal
                      information is designated and assigned an identification
                      code (ID) and password, and the password is regularly
                      updated.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑧ The company prevents information leakage by employees in
                      advance by requiring new employees to sign the Privacy
                      Protection Pledge when hiring, and establishes and
                      constantly implements internal procedures to audit the
                      implementation of personal information processing policies
                      and compliance with employees.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑨ The company prevents the person who handled the
                      customer's personal information from compromising,
                      infringing, or divulging the personal information by
                      requiring them to sign the Privacy Protection Pledge when
                      they retire.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑩ The Company check the customer's identity when
                      collecting or providing payment information such as credit
                      card numbers and bank settlement accounts for the purpose
                      of signing service contracts and providing services.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑪ The company is not responsible for accidents or events
                      caused by a user's personal mistake or basic internet
                      risk. Each member should appropriately manage own ID and
                      password and be responsible for it for personal
                      information protection. Also, it is recommended to avoid
                      using an easy password that others might be able to guess
                      and to change the password regularly.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑫ When you want to stop using our service while you are
                      logged in to our website on a shared PC, make sure that
                      you have logged out and close the webpage before moving to
                      another website. Otherwise, information such as e-mail and
                      password can be easily leaked to others through the
                      browser.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑬ In other cases of personal information loss, disclosure,
                      falsification and damage due to a mistake by an internal
                      managing staff or a technological management accident, the
                      Company will inform you instantly and look for appropriate
                      response and compensation method.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">
                  Restriction on the Use of Personal Data Through External APIs
                </h4>
                <ul>
                  <li>
                    <p className="contents">
                      We do not use user data collected via external APIs,
                      including the Google Workspace API, for the development,
                      improvement, or training of generalized artificial
                      intelligence (AI) and machine learning (ML) models.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              8. Personal Information Management Officer
            </h3>
            <p className="contents">
              We value the Personal Information of our customers and try our
              best not to prevent member's personal information from being
              damaged, infringed, or leaked. In the event of an infringement of
              a member's personal information due to the Company's fault, we
              notify the member in accordance with the procedures and methods
              prescribed by the relevant laws and regulations such as the
              Personal Information Protection Act and the Information and
              Communication Network Act and report to related organization.
              However, the Company is not responsible for information damage by
              unexpected accident caused by basic network threats such as
              hacking occurring despite technological security measures in place
              and disputes over posts written by visitor.
            </p>
            <p className="contents">
              The Company appointed a Personal Information Manager and a
              relevant department as below, to protect the personal information
              of our customers and to take care of any complaints and inquiries
              related to this information.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th" scope="col"></th>
                  <th className="th" scope="col">
                    Personal Information Manager
                  </th>
                  <th className="th" scope="col">
                    Personal Information Management Staff
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="th" scope="row">
                    Name
                  </th>
                  <td className="td">Young-gil Kim</td>
                  <td className="td">Hyunsu Park</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    Title
                  </th>
                  <td className="td">Managing Director</td>
                  <td className="td">Principal Research Engineer</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    E-mail
                  </th>
                  <td className="td">kimyg@fasoo.com</td>
                  <td className="td">hspark@fasoo.com</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    Phone
                  </th>
                  <td className="td" colSpan={2}>
                    82)2-300-9120
                  </td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">9. Obligation for Notification</h3>
            <p className="contents">
              The current privacy policy was revised on March 14, 2025. Should
              there be information to be added, deleted, and edited according to
              government policies or a change in the security technology,
              notification of this will be provided via the website at least
              seven days before the revision.
            </p>
            <p className="contents">
              The privacy policy takes effect on March 14, 2025
            </p>
          </li>
        </ul>
      )}
    </Box>
  );
};

export default PrivacyPage;
